import React from 'react';
import { Components } from '@/apps/appCreator/outsideComponents';
import AuiCarsItemPrice from '@/apps/appCreator/components/CarsItemPrice';

const CarsItemPrice: Components['CarsItemPrice'] = ({ car }) => {
  return (
    <AuiCarsItemPrice
      price={car.extra.dealerPrice}
      discountPrice={car.extra.dealerDiscountPrice}
      hasDiscount={car.extra.hasDealerDiscounts}
    />
  );
};

export default CarsItemPrice;
